import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Navbar from './components/layout/Navbar';
import HomePage from './pages/HomePage';
import ATesterPage from './pages/ATesterPage';
import CartePage from './pages/CartePage';
import AuthPage from './pages/AuthPage';
import ConfirmationPage from './pages/ConfirmationPage';
import AddRestaurantModal from './components/restaurant/AddRestaurantModal';
import { Spinner } from './components/ui/UI';

function AppInner() {
  const { user, loading } = useAuth();
  const [addOpen, setAddOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🍜</div>
        <Spinner size={32} />
      </div>
    </div>
  );

  return (
    <Routes>
      {/* Page de confirmation email — accessible sans auth */}
      <Route path="/confirmation" element={<ConfirmationPage />} />

      <Route path="/auth" element={user ? <Navigate to="/" /> : <AuthPage />} />

      <Route path="/*" element={
        <>
          <Navbar onAddClick={() => setAddOpen(true)} />
          <Routes>
            <Route path="/" element={<HomePage key={refreshKey} onAddClick={() => setAddOpen(true)} />} />
            <Route path="/a-tester" element={<ATesterPage key={refreshKey} onAddClick={() => setAddOpen(true)} />} />
            <Route path="/carte" element={<CartePage onAddClick={() => setAddOpen(true)} />} />
          </Routes>
          {user && (
            <AddRestaurantModal
              open={addOpen}
              onClose={() => setAddOpen(false)}
              onAdded={() => setRefreshKey(k => k + 1)}
            />
          )}
        </>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppInner />
      </AuthProvider>
    </BrowserRouter>
  );
}
